import styled from '@emotion/styled';
import { useContext } from 'react';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@dnhb/node_package';
import { Box, Flex, Stack } from '../../shared/layouts';
import ProgressBar from '../../shared/ProgressBar';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
import BackButton from '../../shared/BackButton';
import { useTranslation } from 'react-i18next';

const consistentBackgroundColor = '#ffffff';

const Wrapper = styled(Box)({
  boxSizing: 'border-box',
  minHeight: '100vh',
  width: '100%',
  padding: '0 0 32px',
  backgroundColor: consistentBackgroundColor
});

const Container = styled(Flex)({
  flexFlow: 'wrap',
  width: '100%',
  maxWidth: '496px',
  boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.12)',
  borderRadius: '4px 4px 0 0',
  overflow: 'hidden',
  border: 0
});

const LogoBox = styled(Flex)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: consistentBackgroundColor,
  borderRadius: theme.borderRadius
}));

const Header = styled(Box)(({ theme }) => ({
  height: '64px',
  width: '100%',
  backgroundColor: theme.colors.primary,

  '&::before': {
    content: '""',
    position: 'absolute',
    top: '32px',
    left: '0',
    right: '0',
    height: '32px',
    backgroundColor: consistentBackgroundColor,
    borderTopLeftRadius: theme.borderRadius,
    borderTopRightRadius: theme.borderRadius
  }
}));

const LoginContainer = ({
  children,
  handleSubmit,
  hideUwKluisLogo,
  width,
  advisorWebsiteUrl
}) => {
  const { Logo } = useContext(WhiteLabelContext);
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  const { t } = useTranslation();

  const AdvisorLinkWrapper = ({ children }) => (
    <a href={advisorWebsiteUrl} target={'_blank'} rel={'noreferrer'}>
      {children}
    </a>
  );

  return (
    <Wrapper>
      <Header />
      {!hideUwKluisLogo ? (
        <LogoBox
          px={{ mobile: 'm', ml: '3xl' }}
          justifyContent={{ mobile: 'center', ml: 'flex-start' }}
        >
          {advisorWebsiteUrl ? (
            <AdvisorLinkWrapper>
              <Logo css={{ maxHeight: isMinDesktop ? '80px' : '56px' }} />
            </AdvisorLinkWrapper>
          ) : (
            <Logo css={{ maxHeight: isMinDesktop ? '80px' : '56px' }} />
          )}
        </LogoBox>
      ) : null}
      <Flex px={'m'} mt={'l'} justifyContent={'center'}>
        <Container width={width}>
          <Box
            as="form"
            p="2xl"
            pb="4xl"
            onSubmit={handleSubmit}
            flex="1"
            bg="white"
          >
            <Stack space="l">
              {advisorWebsiteUrl && (
                <AdvisorLinkWrapper>
                  <BackButton onClick={() => null}>
                    <strong>{t('Terug naar de website')}</strong>
                  </BackButton>
                </AdvisorLinkWrapper>
              )}
              {children}
            </Stack>
          </Box>
          <ProgressBar value={1} total={1} flex="0 0 100%" />
        </Container>
      </Flex>
    </Wrapper>
  );
};

export default LoginContainer;
